import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';

function ParagraphWidget(props) {
    var _props$schema = props.schema,
        title = _props$schema.title,
        text = _props$schema.text;


    return React.createElement(
        'div',
        null,
        React.createElement(
            FormLabel,
            { component: 'legend' },
            title
        ),
        React.createElement(
            'p',
            { style: { whiteSpace: "pre-wrap" } },
            text
        )
    );
}

export default ParagraphWidget;